module.exports = __webpack_public_path__ + "img/rubyonrails-logo.8b3d3bca.png";